module.exports = __webpack_public_path__ + "img/20210610-IMG_05681.6f766e71.jpg";